"use client";
import Logo from "@/components/common/Logo";
import LoginForm from "@/components/forms/LoginForm";

export default function LoginPage() {

  return (
    <div className="">
      <div className="flex items-center justify-center min-h-screen  bg-gradient-to-br from-blue-50 via-yellow-50 to-blue-100">
        <div className="relative w-full max-w-md">
          {/* Logo & Header */}
          <div className="text-center mb-6">
            <div className="flex items-center justify-center mb-4">
              <Logo />
            </div>
          </div>
          {/* Card */}
          <div className="bg-white/80 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-4">
            <div className="text-center mb-6">
              <h2 className="text-2xl font-semibold text-gray-800 mb-2">Welcome Back</h2>
              <p className="text-gray-600 text-sm">Sign in to manage educational content</p>
            </div>
            <LoginForm />
          </div>
          {/* Footer */}
          <div className="text-center mt-6 text-xs text-gray-500">
            <p>
              © {new Date().getFullYear()} Desh Apnayen Sahayog Foundation. Empowering education
              through technology.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
